import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { GetCollection, getMedia } from '../../../firebase/firebase'
import { TikTokCard } from './media.constants'

export default function Media() {
    const [loading, setLoading] = useState(true)
    const [tikToks, setTikToks] = useState([])
    const [otherVideos, getOtherVideos] = useState([])

    useEffect(() => {
        if (loading) {
            GetCollection('media', true, 'type', 'tikTok').then((data) => {
                setTikToks(data.docs.map(doc => doc.data()))
            })
        }
    }, [loading])

    return (
        <Container>
            <Row className='py-2'>
                {tikToks && tikToks.map((tikTok, i) => {
                    return (
                        
                            <Col lg={4} key={i} >
                                <TikTokCard media={tikTok}/>
                            </Col>
                        


                    )
                })}
            </Row>
        </Container>

    )
}